import { useWindow } from "../../contexts/WindowContext";
import "../../Styles/Modals/NewWindowModal.css";

export const NewWindowModal = () => {
  const { isNewWindowModalOpen, newWindowModalLink, closeNewWindowModal, addAllowedLink} = useWindow();

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) closeNewWindowModal();
  };

  const handleOpenLink = () => {
    addAllowedLink(newWindowModalLink);
    window.open(newWindowModalLink, '_blank');
    closeNewWindowModal();
  };

  if (!isNewWindowModalOpen) return null;

  return (
    <div className="new-window-modal-overlay" onClick={handleOverlayClick}>
      <div className="new-window-modal-content">
        <div className="new-window-modal-header">
          <h1>Open Link in New Window</h1>
        </div>
        <div className="new-window-modal-body">
          <p className="new-window-modal-body-text">You are about to open this link in a new window. Do you want to continue?</p>
          <span className="new-window-modal-link">{newWindowModalLink}</span>
        </div>
        <div className="new-window-modal-footer">
            <button 
              className="confirmation-cancel-button"
              onClick={closeNewWindowModal}
              autoFocus
            >
              Cancel
            </button>
            <button 
              className="confirmation-confirm-button"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenLink();
              }}
            >
              Open
            </button>
        </div>
      </div>
    </div>
  );
}